
class Video {
  constructor() {
    Video.init();
  }

  static init() {
    [].forEach.call(window.wrapper.querySelectorAll('.block--video'), (block) => {
      const play = block.querySelector('.block--video__play');
      const iframe = block.querySelector('iframe');
      play.addEventListener('click', (e) => {
        e.preventDefault();
        block.classList.add('active');
        iframe.src = iframe.dataset.video;
      });

      iframe.addEventListener('mouseenter', () => window.cursor.enter(false, true));
      iframe.addEventListener('mouseleave', () => window.cursor.leave());
    });
  }
}

export default Video;
